/* @flow */
import * as React from 'react';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import { BaseWidgetProps, DiagramEngine } from 'storm-react-diagrams';
import { DiscussionServiceHelper } from 'src/store/scenario/items';
import ItemNodeWidget from '../ItemNodeWidget';

export interface AnswerNodeProps extends BaseWidgetProps {
  discussionId: string;
  messageId: string;
  answerId: string;
  nodeId: string;
  outOfRedux: boolean;
  item: any;
  deleteAnswer: DiscussionServiceHelper.deleteAnswerType;
  diagramEngine: DiagramEngine;
}

export interface ItemNodeState {}

class AnswerOpenedNodeWidget extends ItemNodeWidget<AnswerNodeProps, ItemNodeState> {
  state = {};

  entityRemoved() {
    const {
      deleteAnswer, discussionId, messageId, nodeId,
    } = this.props;
    if (deleteAnswer) {
      deleteAnswer(discussionId, messageId, nodeId);
    }
  }

  parentChanged() {
    this.forceUpdate();
  }

  reachableChanged() {
    this.forceUpdate();
  }

  componentDidUpdate(oldProps) {
    const hasParentId = this.props.hasParentId;
    const hasParent = this.props.hasParent;
    const hadParent = oldProps.hasParent;
    const { nodeId, diagramEngine } = oldProps;
    if (hasParentId && hadParent && !hasParent) {
      diagramEngine.diagramModel.removeNode(nodeId);
    }
  }

  render() {
    return (
      <div
        {...this.getProps()}
        style={{
          background: this.props.bgColor,
          borderColor: this.props.borderColor,
        }}
      >
        <div
          className={`answerOpened_graph_title ${this.bem('__title')}${this.props.nextCustomClass}${
            this.props.defaultClass
          }`}
        >
          <div className={this.bem('__name')}>{this.props.title}</div>
        </div>
        <div className={this.bem('__ports')}>
          <div className={this.bem('__in')}>{_.map(this.props.node.getInPorts(), this.generatePort.bind(this))}</div>
          <div className={this.bem('__out')}>{_.map(this.props.node.getOutPorts(), this.generatePort.bind(this))}</div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { node, answer } = ownProps;
  const { discussionId } = node;
  const nodeId = answer && answer.nodeId;
  const messageId = answer && answer.parentMessageId;
  const discussion = discussionId && state.scenario.items[discussionId];
  let answerRedux;
  let isAccessible;
  let messageRedux;
  if (discussion) {
    if (!messageId) {
      answerRedux = discussion.__detachedNodes.answersOpened.find(ans => ans.nodeId === nodeId);
      if (answer && answerRedux && ownProps.node.item.parentMessageId !== answerRedux.parentMessageId) {
        // eslint-disable-next-line no-param-reassign
        ownProps.node.item.parentMessageId = answerRedux.parentMessageId;
        messageRedux = discussion.messages[answerRedux.parentMessageId];
      }
      if (answerRedux.id) {
        // eslint-disable-next-line no-param-reassign
        ownProps.node.item.id = answerRedux.id;
      }
    } else {
      messageRedux = messageId && discussion.messages[messageId];
      answerRedux = messageRedux && messageRedux.answersOpened.find(ans => ans.nodeId === nodeId);
      isAccessible = answerRedux && messageRedux.isAnswerOpenedAccessible(answerRedux);
    }
    if (!answerRedux) {
      answerRedux = discussion.__detachedNodes.answersOpened.find(ans => ans.nodeId === nodeId);
      if (answerRedux) {
        // eslint-disable-next-line no-param-reassign
        delete ownProps.node.item.parentMessageId;
      }
    }
    if (ownProps.node.item && !ownProps.node.item.id && answerRedux.id) {
      // eslint-disable-next-line no-param-reassign
      ownProps.node.item.id = answerRedux.id;
    }
  }
  const locale = state.preferences.editionLocale;
  const content = answerRedux && answerRedux.contentsRecognized;
  const translatedContent = content && content.valueForLocale(locale, true);
  const displayContent = translatedContent && translatedContent.join ? translatedContent.join(', ') : '';
  const isDefault = answerRedux && answerRedux.isDefault;
  const hasNextCustom = answerRedux && answerRedux.nextCustom;
  let color;
  if (messageRedux) {
    color = messageRedux.answerMode === 'System' ? '#00E0CC' : '#001B48';
  } else {
    color = '#F5A623';
  }
  return {
    borderColor: !isAccessible ? 'red' : ownProps.node.borderColor,
    nodeId,
    messageId,
    discussionId,
    answer: answerRedux,
    title: isDefault ? 'Default' : displayContent,
    nextCustomClass: hasNextCustom ? ' nextCustomAnswer ' : '',
    isDefaultClass: isDefault ? ' defaultClass' : '',
    hasParentId: !!messageId,
    hasParent: !!messageId && !!discussion.messages[messageId],
    bgColor: color,
  };
};

const mapDispatchToProps = {
  deleteAnswer: DiscussionServiceHelper.deleteAnswerOpenedAsync,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AnswerOpenedNodeWidget);
